import React from 'react';
import { func } from 'prop-types';
import {
  Button,
  Typography,
} from '@material-ui/core';

import styles from './styles.scss';

const PractitionerRegister = ({ locationPractitionerLogin }) => (
  <div className={styles.practitionerRegisterWrapper}>
    <div className={styles.heading}>
      <Typography variant='h2'>Register</Typography>
      <Typography variant='body1'>
        TeleConsult powered by Amazon Chime is no longer available for new users.{' '}
        If you are an existing TeleConsult user you may can continue to use this{' '}
        product with your previous registration details.
      </Typography>
    </div>
    <Typography className={styles.dividerText} variant='body1'>
      <span>
        Already have an account or Gentu user?
      </span>
    </Typography>
    <Button
        fullWidth
        color='primary'
        onClick={locationPractitionerLogin}
        variant='contained'
      >
        Login
      </Button>
  </div>
);

PractitionerRegister.propTypes = {
  locationPractitionerLogin: func.isRequired,
};

export default PractitionerRegister;
